import React, { useEffect, useContext } from 'react';
import { CircularProgress, Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { useDrawer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useLoadOne } from 'src/mtska-frontend-data-provider/hooks/useLoadOne.hooks';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import Create from './Create';
import { Backdrop } from "@mui/material"

const dataProviderName = 'audiences/audiencesegment';
const model = 'audiences/audienceSegment';

const Detail = (params) => {
    const { t } = useTranslation();
    const { close: closeDrawer } = useDrawer();
    const { existingModules } = useContext(AppContext);

    const { item, loadOne, errorMessage, saving, reloadCounter, doAction } = useDataProvider(dataProviderName, params.multipart);

    useLoadOne({ loadOne, params, reloadCounter });

    const handleSave = (data) => {
        const payload = { ...data, filters: params.filters };
        return doAction({
            action: 'actionUpdate',
            model: model,
            data: payload
        }).then(result => params.handleClose?.(params.uid, result))
            .catch(error => console.error(error));
    };

    if (!item?.data) return <Backdrop open={true} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop>;

    return (
        <Create
            {...params}
            item={item?.data || {}}
            defaultRules={item?.data?.rules || []}
            wizardAction="actionUpdate"
            onSave={handleSave}
            id={item?.data?.id || params.id}
        />
    );
};

export default Detail;
